import gql from "graphql-tag";
import GraphQLClient, { RequestParam } from "../api";
import { Theme } from "../models/theme";

interface IThemeClient {
  fetchTheme: (novelId: string) => Promise<Theme>;
  updateNovelTheme: (novelId: string, detail: { name: string; value: string }[]) => Promise<void>;
}

export class ThemeClient implements IThemeClient {
  async fetchTheme(novelId: string): Promise<Theme> {
    const params: RequestParam = {
      query: fetchTheme,
      variables: {
        novelId,
      },
    };

    const { theme } = await GraphQLClient.request(params);
    return theme;
  }

  async updateNovelTheme(novelId: string, detail: { name: string; value: string }[]): Promise<void> {
    const params: RequestParam = {
      query: updateTheme,
      variables: {
        input: {
          novelId,
          detail,
        },
      },
    };

    await GraphQLClient.request(params);
  }
}

const fetchTheme = gql`
  query Theme($novelId: ID!) {
    theme(novelId: $novelId) {
      novelId
      detail {
        name
        value
      }
    }
  }
`;

const updateTheme = gql`
  mutation UpdateTheme($input: UpdateThemeInput!) {
    updateTheme(input: $input) {
      novelId
      detail {
        name
        value
      }
    }
  }
`;
